import {Component, Inject, OnInit, TemplateRef} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PositionAliasTo } from 'src/app/shared/models/positionAliasTo';
import { PositionAliasService } from '../position-alias.service';
import {SharedService} from '../../shared/shared.service';
import {Alerts} from '../../shared/enums/alerts';
import { PositionAliasBase } from '../position-alias-base';
import Swal from 'sweetalert2/dist/sweetalert2.js';


@Component({
    selector: 'app-update-position-alias',
    templateUrl: './update-position-alias.component.html',
    styleUrl: './update-position-alias.component.scss'
})
export class UpdatePositionAliasComponent extends PositionAliasBase implements OnInit {

    positionAlias: PositionAliasTo;
    resetData: PositionAliasTo;
    header = "Update Position Alias";
    title: string;
  
    constructor(@Inject(MAT_DIALOG_DATA) public data : PositionAliasTo,
                public dialogRef: MatDialogRef<UpdatePositionAliasComponent>,
                public sharedService: SharedService,
                public positionAliasService: PositionAliasService) {
        super();
    }
  
    ngOnInit() {
        this.positionAlias = new PositionAliasTo(this.data);
        this.resetData = new PositionAliasTo(this.positionAlias);
        this.title = this.positionAlias.org.name;
    }

    updatePositionAlias() {
        this.markFormControlsAsTouched();
        if (this.positionId.valid && this.alias.valid) {
            if (this.resetData.positionId !== this.positionAlias.positionId || this.resetData.alias !== this.positionAlias.alias) {
                this.loading = true;
                this.positionAliasService.updatePositionAlias(this.positionAlias).subscribe({
                    next: data => {
                        this.loading = false;
                        this.sharedService.showAlert(Alerts.SUCCESS, 'Position Alias updated successfully');
                        this.dialogRef.close(true);
                    },
                    error: error => {
                        this.loading = false;
                        this.sharedService.handleErrors(error,
                            [{
                                "condition": (error.status === 400 && error.error?.length > 0),
                                "msg": error.error
                            }],
                            "Unable to update position alias");
                    },
                    complete: () => { }
                });
            } else {
                this.sharedService.showAlert(Alerts.ERROR, 'No changes have been made');
            }
        } 
    }

    resetPositionAlias() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.positionAlias = new PositionAliasTo(this.resetData);
                }
            });
        } else {
            this.positionAlias = new PositionAliasTo(this.resetData);
        }
    }

    close() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved !',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }
    

}
